var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_641_451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_451",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_451",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_451",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA7lJREFUWIXFlktsG1UUhr8zM3bT1hS3xLHj2sGiiZ3IEBW5iAISoPASr7RCygKxgiCxYsOGbdtFu60qFqCuWAASRIISJKQuoGLBIpILUjE1aakU1zRvoJZpm9gzh4Udd2I7Vew68G+sOWfu/3+6d2aOhfZkhKKJI8DbAIicnstljwJOq0ZmO+nBvsS7AieALmAHMOLbFVgqFpamWvUy2gEQOAygjvGk48hTFSd9rR2vpgDhcLw7FE18HuwbfKVZX2E3gJrcgyk+d61evdHBF4LRxJfhcLx7cwCplMcxZQIYM9R5zN0KRIYGeiOJk6LEAQx1zhrqnAUQJd4bSZwMRJL962DVOShw2DFlglTKUx/X8AyErHtPAWPAlKU33ioUCmXADEUTRw3RTxGeABqMAA/CQUOcd3z+gFW8vvQDoP5d26cc8T4PPO67seIvXl/+1r1I3Bc9kcSwIfwEulg2zIeXZi7OJpNJ73KhPAG82iR0Qwmcme3xjZFOlyKR+N4ych6hW1X2z+ezF9buW3cEhsEJwBDkyNLMxVmA5ULpo1bDARQOhRaKHwLk89N/IHqs4u0crwOtKBBJ9ptSvgT8PtfjGyKdLgWjiUMCX7Uavg5EZHQ+l50klfKEFopZ4AEV3Tefm74Crh2wpDRaQZJPSKdLVbpjdxMOIKrHASGdLil8Vq3WdtR1BMaLFWTnG4BgZOBRYPhuAYAHQ9H4gar3ZOWXlxoAVHUAsOeuTp+vdMyRDoRXJDICMJ/fmwZsgYF6AEEIAfOADSCq/fU+bedD1etcGVgEwlSfPwMgmUx6AAfk8u1l6u8UgKruceFMA041Ewsgk8ms9tw/+KxVKl2tLUIMoTNSpHbUtprjlpT9mUxmtQYAsDCT/dG9SNqclM3k9lrMZy67e3eahsFOAYAGNurcCaC3cwASagkgGBzeCWy4qA2Fw+HUjk0DmN5bz9F84rUrr23988ymAVTk5Q6GV021qWfDmxaLxfy37G1X2OAfTtv58LdHrX35fOZPd71hB1bKXe93OhxAwF+S8ntN6rcVig3GsPUXYGenAaoqGraVvHYtk1sr1HYgFot1YesXWxgO4LOt8hn3G1EDWLG3fQAc2MJwAETZr2bxVB3A05bCG1sdviaF16l+nquz4FxZGXpExBn6bxDMX6mO/f9dLU3cvr6Hdq/q6tfA9g1uuekV72gud+GvLQEACEUTbwKnaRzXNiLjc7nsx634tTzzi4Xln3f57/tORULAHuAmKt8bBuOzud8mW/X7Fx/OI/FxC/hjAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts1);
export default __webpack_public_path__ + "static/media/alerts1.95d5668077a28d2cbc6f2eb49fa1ac45.svg";
export { ForwardRef as ReactComponent };